<span class="text-danger">
    {{ label() }} must be at most {{ max() }}.
  </span>